/**
 * Отдать файл браузеру на скачивание — так же, как это делают отчёты по страницам
 * (store/modules/intro.js, INTRO_SEND_REPORT): временная ссылка на Blob и клик.
 */
export function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => window.URL.revokeObjectURL(url), 10000);
}
